<template>
  <div class="events__wfh-list">
    <template v-if="wfhAttendees.length > 0">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           viewBox="0 0 512.001 512.001" xml:space="preserve" style="height: 0.8em">
          <path d="M503.402,228.885L273.684,19.567c-10.083-9.189-25.288-9.188-35.367-0.001L8.598,228.886
            c-8.077,7.36-10.745,18.7-6.799,28.889c3.947,10.189,13.557,16.772,24.484,16.772h36.69v209.721
            c0,8.315,6.742,15.057,15.057,15.057h125.914c8.315,0,15.057-6.741,15.057-15.057V356.932h74.002v127.337
            c0,8.315,6.742,15.057,15.057,15.057h125.908c8.315,0,15.057-6.741,15.057-15.057V274.547h36.697
            c10.926,0,20.537-6.584,24.484-16.772C514.147,247.585,511.479,236.246,503.402,228.885z" fill="white"/>
          <path d="M445.092,42.73H343.973l116.176,105.636v-90.58C460.149,49.471,453.408,42.73,445.092,42.73z" fill="white"/>
      </svg>
      {{ readableList(wfhNameList) }}
      <template v-if="wfhAttendees.length === 1">
        is
      </template>
      <template v-else>
        are
      </template>
      WFH
    </template>
  </div>
</template>

<script>
  import StringMixins from './StringMixins.vue';

  export default {
    name: 'WFHList',
    mixins: [StringMixins],
    data: function() {
      return {
        wfhAttendees: []
      };
    },
    props: {
      gCalApi: Object,
      event: Object
    },
    computed: {
      wfhNameList: function() {
        return this.wfhAttendees.map(a => this.personName(a));
      },
      eventId: function() {
        return this.event.id;
      }
    },
    watch: {
      eventId: function() {
        this.getWfhAttendees();
      }
    },
    methods: {
      personName: function(person) {
        if(person.hasOwnProperty('displayName')) {
          return person.displayName;
        } else {
          return this.nameFromEmailAddress(person.email)
        }
      },
      getWfhAttendees: function() {
        //timeMax must be greater than timeMin in call to events.list
        const timeMax = new Date();
        timeMax.setSeconds(timeMax.getSeconds() + 1);

        this.gCalApi.client.calendar.events.list({
          'calendarId': 'staff.leave@fivium.co.uk',
          'timeMin': (new Date()).toISOString(),
          'timeMax': timeMax.toISOString(),
          'showDeleted': false,
          'singleEvents': true,
          'maxResults': 100,
          'orderBy': 'startTime'
        }).then((response) => {
          const events = response.result.items.reverse();
          const allWfhPeople = events
            .filter(e => e.summary.toLowerCase().includes('wfh') || e.summary.toLowerCase().includes('working from home'))
            .map(e => e.creator.email);

          this.wfhAttendees = this.event.attendees.filter(a => a.responseStatus != 'declined' && allWfhPeople.includes(a.email));
        });
      }
    },
    mounted: function() {
      this.getWfhAttendees();
    }
  }
</script>
